/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getFormValues, reduxForm } from 'redux-form';
import { useLocation } from 'react-router';
import saga from '../../saga';
import reducer from '../../reducer';
import { useInjectReducer } from '../../../../../utils/injectReducer';
import { useInjectSaga } from '../../../../../utils/injectSaga';
import { CompanyAdminSettingsContent } from './components/company-settings-content';
import {
	getCompanyAdminSettingInfoSelector,
	getFormInitialCompanyAdminSettingValuesSelector,
	getIsCompanyAdminSettingLoadingSelector,
} from '../../selectors';
import { resetStateAction } from '../../actions';
import { FORM_SETTINGS_ADMIN_NAME } from '../../constants';

const CompanyAdminSettingsWrapper = ({
	isCompanyAdminSettingInfoLoading,
	companyAdminSettingInfo,
	change,
	formValues,
}) => {
	useInjectSaga({ key: 'companiesModalSaga', saga });
	useInjectReducer({ key: 'companiesModalReducer', reducer });
	const { search } = useLocation();

	const query = new URLSearchParams(search);

	const mode = query.get('mode');

	const isEditing = mode === 'modules-edit';

	return (
		<CompanyAdminSettingsContent
			isCompanyAdminSettingInfoLoading={isCompanyAdminSettingInfoLoading}
			companyAdminSettingInfo={companyAdminSettingInfo}
			isEditing={isEditing}
			formValues={formValues}
			change={change}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	companyAdminSettingInfo: getCompanyAdminSettingInfoSelector(),
	isCompanyAdminSettingInfoLoading: getIsCompanyAdminSettingLoadingSelector(),
	formValues: getFormValues(FORM_SETTINGS_ADMIN_NAME),
	initialValues: getFormInitialCompanyAdminSettingValuesSelector(),
});

const mapDispatchToProps = {
	onResetState: resetStateAction,
};

const withForm = reduxForm({
	form: FORM_SETTINGS_ADMIN_NAME,
	enableReinitialize: true,
	keepDirtyOnReinitialize: true,
})(connect(mapStateToProps)(CompanyAdminSettingsWrapper));

const CompanyAdminSettings = connect(mapStateToProps, mapDispatchToProps)(withForm);

CompanyAdminSettingsWrapper.propTypes = {
	companyAdminSettingInfo: PropTypes.object,
	isCompanyAdminSettingInfoLoading: PropTypes.bool.isRequired,
	relationshipSettingHeader: PropTypes.string,
	activeCompanyId: PropTypes.string,
	onResetState: PropTypes.func.isRequired,
	formValues: getFormValues(FORM_SETTINGS_ADMIN_NAME),
	change: PropTypes.func.isRequired,
};

export default CompanyAdminSettings;
